export const subjectLabels: Record<string, string> = {
  AL: "Alarm",
  BM: "BaseManager",
  CM: "Cell Modem",
  FM: "Flow Meter",
  FS: "FlowStation",
  ML: "Mainline",
  MS: "Moisture Sensor",
  MV: "Master Valve",
  PC: "Point of Connection",
  PG: "Program",
  SW: "Event Switch",
  SY: "System",
  TS: "Temperature Sensor",
  TW: "Two-Wire",
  WF: "Wi-Fi",
  ZN: "Zone",
  ZP: "Primary Zone",
};

export const actionLabels: Record<string, string> = {
  BT: "Boot",
  CA: "Clear All",
  CB: "Calibration",
  CC: "Configuration Change",
  CL: "Clear",
  CN: "Connected",
  DB: "Debug",
  DC: "Disconnected",
  DN: "Done",
  DS: "Disabled",
  ER: "Error",
  EV: "Event Day",
  FF: "Flow Fault",
  FH: "High Flow",
  FV: "Flow Variance",
  IP: "IP Address Change",
  LF: "Learn Flow",
  LI: "Login",
  LR: "Learn Flow Results",
  MR: "Manual Run",
  PA: "Paused",
  RD: "Rain Delay",
  RL: "Running List",
  RN: "Run",
  RS: "Rain Switch",
  RX: "Received",
  SE: "Set",
  SK: "Skipped",
  SO: "Soak",
  SP: "Stopped",
  SR: "Started",
  ST: "Status",
  TR: "Test Results",
  TS: "Testing",
  TT: "Two-Wire Test",
  TX: "Transmitted",
  UD: "Updated",
  UN: "Unassigned",
  VT: "Variance Test",
  WA: "Waiting",
  WT: "Watering",
};

export const triggerLabels: Record<string, string> = {
  AD: "Administrator",
  AK: "Alarm Key",
  BL: "BLCommander",
  BM: "BaseManager",
  CM: "Cell Modem",
  DL: "Dial",
  DT: "Date/Time Schedule",
  ED: "Event Date",
  ET: "Ethernet",
  FJ: "Flow Jumper",
  FM: "Flow Meter",
  FS: "FlowStation",
  ML: "Mainline",
  MS: "Moisture Sensor",
  MV: "Master Valve",
  OP: "Operator",
  PC: "Point of Connection",
  PG: "Program",
  PJ: "Pause Jumper",
  PP: "Program Priority",
  PR: "Programmer",
  PU: "Power Up",
  PZ: "Primary Zone",
  RA: "Rain Shutdown",
  RJ: "Rain Jumper",
  SW: "Event Switch",
  SY: "System",
  TS: "Temperature Sensor",
  TW: "Two-Wire",
  UD: "Update",
  US: "User",
  WD: "WatchDog",
  WW: "Water Window",
  ZN: "Zone",
};

export const detailLabels: Record<string, string> = {
  B1: "BaseManager Server",
  BP: "BaseManager Alternate IP",
  BS: "BaseManager Static IP",
  BT: "BaseManager Test Server",
  CA: "Calibrate",
  CF: "Concurrent Zones By Flow",
  CN: "Connection Type",
  CP: "Depth Compensation",
  CT: "Cycle Time",
  CX: "Concurrent Zones",
  D1: "Ethernet DNS 1",
  D2: "Ethernet DNS 2",
  DF: "Design Flow",
  DH: "Ethernet DHCP",
  DI: "Day Interval",
  DS: "Description",
  DT: "Date & Time",
  EM: "Empty Time",
  EN: "Enabled",
  ER: "Error",
  ET: "ET Intervals",
  FI: "File",
  FM: "Flow Meter",
  GE: "General Exception",
  GW: "Ethernet Gateway",
  HE: "High Flow Enabled",
  HF: "High Flow Limit",
  HS: "High Flow Shut Down",
  HV: "High Flow Variance",
  HX: "High Flow Variance Enabled",
  ID: "ID",
  IP: "IP Address",
  KV: "K Value",
  LA: "Latitude",
  LF: "Learn Flow",
  LG: "Longitude",
  LL: "Lower Limit",
  LM: "Limit",
  LN: "Language",
  LS: "Low Flow Variance Shutdown",
  LV: "Low Flow Variance",
  LX: "Low Flow Variance Enabled",
  MB: "Monthly Budget",
  ME: "Monthly Budget Enabled",
  ML: "Mainline",
  MS: "Moisture Sensor",
  MT: "Master Valve Type",
  MV: "Master Valve",
  NU: "Number",
  OS: "Offset",
  P1: "POC Moisture Sensor Enabled",
  PB: "Booster Pump",
  PC: "Point of Connection",
  PF: "Pipe Fill Time",
  PG: "Program",
  PI: "Personal Identification Number",
  PP: "Primary Zone Program",
  PR: "Priority",
  PT: "Pause Time",
  PW: "POC Switch Enabled",
  PZ: "Primary Zone",
  RD: "Rationing Daily",
  RL: "Run Time Limit",
  RM: "Run Mode",
  RT: "Run Time",
  SB: "Ethernet Subnet",
  SC: "Water Schedule",
  SD: "Shut Down Days",
  SG: "Water Strategy",
  SL: "Sensor Limit",
  SN: "Serial Number",
  SO: "Soak Time",
  SP: "Step",
  SS: "Status",
  ST: "Start Times",
  SU: "Shut Down",
  SW: "Event Switch",
  T7: "Two-Wire 24x7",
  TR: "Tracking Ratio",
  TS: "Temperature Sensor",
  TW: "Two-Wire Mode",
  TX: "Text",
  UE: "Unscheduled Flow Enabled",
  UF: "Unscheduled Flow",
  UL: "Upper Limit",
  VA: "Value Amps",
  VC: "Value Switch",
  VD: "Value Degrees",
  VE: "Version",
  VG: "Value Gallons",
  VP: "Value Percent",
  VR: "Value GPM",
  VS: "Value Seconds",
  VT: "Value Voltage Drop",
  VV: "Value Voltage",
  W0: "Water Window Sunday",
  W1: "Water Window Monday",
  W2: "Water Window Tuesday",
  W3: "Water Window Wednesday",
  W4: "Water Window Thursday",
  W5: "Water Window Friday",
  W6: "Water Window Saturday",
  WB: "Water Budget",
  WD: "Water Window Daily",
  WW: "Water Window",
  XP: "FlowStation IP",
  ZN: "Zone",
  ZT: "Zone Type",
};

export function labelFor(
  dictionary: Record<string, string>,
  code: string,
  fallbackPrefix = "Unknown code",
) {
  return dictionary[code] ?? `${fallbackPrefix}: ${code || "blank"}`;
}
